module.exports = __webpack_public_path__ + "static/media/acumen_commverge0.f8a72d61.png";